import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import SpecialPricing from './SpecialPricing.js';
import Pricing from './Pricing';


const AddImplantMarkers = () => {
  const [isLotRequired, setIsLotRequired] = useState(false);
  const [allowNoteForLot, setAllowNoteForLot] = useState(false);
  const [isSerialRequired, setIsSerialRequired] = useState(false);
  const [allowNoteForSerial, setAllowNoteForSerial] = useState(false);
  const [allSpecial, setAllSpecial] = useState([]);
  const [value, setValue] = useState('');
  const [pricingData, setPricingData] = useState({});


  const handleDataUpdate = (data) => {
    
    setPricingData(data);
  };


  const handleRowsUpdate = (rows) => {
    
    setAllSpecial(rows);
  };


  const handleLotRequiredChange = (e) => {
    setIsLotRequired(e.target.checked);
    if (!e.target.checked) setAllowNoteForLot(false);
  };

  const handleSerialRequiredChange = (e) => {
    setIsSerialRequired(e.target.checked);
    if (!e.target.checked) setAllowNoteForSerial(false);
  };

  const handleValueChange = (e) => {
    setValue(e.target.value);
  };


  const handleSubmit = async(e) => {
    e.preventDefault();
    // Add your form submission logic here


    const inputData = {
      valueName: value,
      isLotRequired,
      allowNoteForLot,
      isSerialRequired,
      allowNoteForSerial,
      pricing:pricingData,
      specialPricing: allSpecial,
    }



    try {
      const response = await fetch('https://hms.backend.hiragroupcloud.com/api/add-implant-marker', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(inputData),
      });
  
      if (response.ok) {
        const data = await response.json();
       
        // navigate(-1);
        // Reset form fields if necessary
      } else {
        console.error('Error submitting form:', response.statusText);
      }
    } catch (error) {
      console.error('Network error:', error);
    }

  };

  const boldStyle = {
    fontWeight: 'bold',
  };

  return (
    <>

            <div style={{width:"1580px"}}>
              <h2 >Add Implant Marker</h2>
              <h4 style={{color:'#004aad'}}>Details</h4>
              <form onSubmit={handleSubmit}>
                <div style={{backgroundColor:"#f4f4f4",borderTop:"2px solid #004aad",padding:"10px"}}>
                <div className="mb-3">
                  <label className="form-label" style={boldStyle}>Value Name *</label>
                  <input type="text" className="form-control" placeholder="Enter Value Name" onChange={handleValueChange} value={value} />
                </div>
                <div className="mb-3" style={{ display: 'flex', alignItems: 'center' }}>
                  <label className="form-label" style={boldStyle}>Lot #</label>
                  <div className="form-check" style={{ marginLeft: '12%' }}>
                    <input type="checkbox" className="form-check-input" checked={isLotRequired} onChange={handleLotRequiredChange} />
                    <label className="form-check-label">Is Required</label>
                  </div>
                  <div className="form-check" style={{ marginLeft: '10px' }}>
                    <input type="checkbox" className="form-check-input" checked={allowNoteForLot} onChange={(e) => setAllowNoteForLot(e.target.checked)} disabled={!isLotRequired} />
                    <label className="form-check-label">Allow Note</label>
                  </div>
                </div>
                <div className="mb-3" style={{ display: 'flex', alignItems: 'center' }}>
                  <label className="form-label" style={boldStyle}>Serial #</label>
                  <div className="form-check" style={{ marginLeft: '10%' }}>
                    <input type="checkbox" className="form-check-input" checked={isSerialRequired} onChange={handleSerialRequiredChange} />
                    <label className="form-check-label">Is Required</label>
                  </div>
                  <div className="form-check" style={{ marginLeft: '10px' }}>
                    <input type="checkbox" className="form-check-input" checked={allowNoteForSerial} onChange={(e) => setAllowNoteForSerial(e.target.checked)} disabled={!isSerialRequired} />
                    <label className="form-check-label">Allow Note</label>
                  </div>
                </div>
                </div>
                <Pricing onDataUpdate={handleDataUpdate} />
                <SpecialPricing onRowsUpdate={handleRowsUpdate} />
               
                  <button className='btn btn-primary mt-4'
                  style={{backgroundColor:"#004aad",borderColor:"#004aad"}}>Save</button>
                </form>
            </div>
         
       
    </>
  );
};

export default AddImplantMarkers;
